import { athenaApi } from './athenaApiGen';

// Codegen (`tag: true`) derives each endpoint's tags from its swagger tag, so
// the library-directory mutations end up tagged only 'Library Directories',
// while the tree the UI renders (getApiLibraryTree / getApiLibrary) provides
// 'Library'. Result: a create/delete/rename of a directory never invalidates
// the tree's cache, so the tree doesn't refetch without a hard refresh
// (issue #1333). Historically every handler compensated with a manual
// `dispatch(athenaApi.util.invalidateTags(['Library']))` — brittle, since any
// new call site (e.g. the Escape-rollback delete) that forgets it reintroduces
// the bug.
//
// `enhanceEndpoints` mutates the shared api instance in place, so the generated
// hooks pick up these overrides. Adding 'Library' to the directory mutations
// makes the tree refetch automatic and central. Living here (not in the
// generated athenaApiGen.ts) keeps it safe across `npm run codegen` regens.
//
// Note: `invalidatesTags` is REPLACED, not merged — so we re-list
// 'Library Directories' to keep the directory-list cache busting too.
athenaApi.enhanceEndpoints({
  endpoints: {
    // Cancelling a deliverable removes its tasks from the approval queue and
    // returns it to Pending, but the codegen tags the endpoint only
    // 'Deliverables' (its swagger tag), so the queue would keep showing the
    // cancelled item and a cached form view (TAR/TR/CTP/PNR/RIP) would reopen
    // read-only until a hard refresh. The workflow PATCH route no longer
    // accepts a reset to Pending, so every Cancel goes through this endpoint.
    postApiDeliverablesByIdCancel: {
      invalidatesTags: [
        'Deliverables',
        'Approval Queue',
        'TAR (Travel Authorization Request)',
        'TR (Trip Report)',
        'CTP (Consent to Purchase)',
        'PNR (Problem Notification Report)',
        'RIP (Request to Initiate Purchase)',
      ],
    },
    postApiLibraryDirectories: {
      invalidatesTags: ['Library', 'Library Directories'],
    },
    deleteApiLibraryDirectoriesByDirectoryId: {
      invalidatesTags: ['Library', 'Library Directories'],
    },
    patchApiLibraryDirectoriesByDirectoryId: {
      invalidatesTags: ['Library', 'Library Directories'],
    },
  },
});
